// Components
import { CalculationOOSLongTwoDayParams } from '../calculation-oos-long-two-day-params/Calculation-oos-long-two-day-params';
import { BtnApplyNewRate } from '../btn-apply-new-rate/Btn-apply-new-rate';
import { CalculationTwoDaysPayment } from '../calculation-two-days-payment/Calculation-two-days-payment';

// import { boxesKey } from '../../util/const';
// Styles
import styles from './CalculationOOSLongTwoDayResult.module.css';
import { BtnApplyNewTemplate } from '../btn-apply-new-template/Btn-apply-new-template';

export const CalculationOOSLongTwoDayResult = (props) => {
  const { calculationData, sameDepartmentSettings, sameOOSDirectionSettings, applyNewRates, sameUnpDepartmentSettings, formChange, resetLastTarget, checkboxValueChange, editorState,
    tags,
    setPreviewText, setOptionsPreviewText,
    popUpShown, oldTemplateWasUsed, applyNewTemplate, setShowGenerateEmail, furniture, roomsAreas, setTagsValuesDefault, customTagsValues, showCustomTags } = props;
  const commonValues = { ...calculationData.commonValues };
  const department = { ...calculationData.department };
  const unpDepartment = { ...calculationData.unpDepartment };
  const outOfState = { ...calculationData.outOfState };
  const oos2days = { ...calculationData.oos2days };
  const selectedMiscCheckMarks = calculationData.selectedMiscCheckMarks

  return (
    <section className={styles.container}>
      <h2 className={styles.title}>Calculation - OOS - 2 days - Packing</h2>
      {(!sameDepartmentSettings || !sameOOSDirectionSettings || !sameUnpDepartmentSettings) && <div className={styles.oldApplyNew}><h2 className={styles.title} style={{ color: "red" }}>Old department or destination settings were used</h2>
        <BtnApplyNewRate
          isActive={true}
          action={applyNewRates}
          name={'Apply new rates'}
        />
      </div>}
      {oldTemplateWasUsed && <div className={styles.oldApplyNew}><h2 className={styles.title} style={{ color: "#0000ff" }}>Old template settings were used</h2>
        <BtnApplyNewTemplate
          isActive={true}
          action={applyNewTemplate}
          name={'Apply new Template'}
        />
      </div>}
      {calculationData &&
        <div className={styles.selectedInfo}>
          {calculationData.calculationNumber && <p className={styles.calculationNumber}>{calculationData.calculationNumber}</p>}
          {calculationData.department && <p className={styles.departmentName}>{calculationData.department.departmentName}</p>}
          {calculationData.oos2days.firstDayRate && <p className={styles.rateName}>{calculationData.oos2days.firstDayRate}</p>}
          {calculationData.oos2days.secondDayRate && <p className={styles.secondRateName}>{calculationData.oos2days.secondDayRate}</p>}
        </div>
      }
      <div className={styles.selectedInfo} style={{ zIndex: '2' }}>
        {oos2days.firstDayDate && <p className={styles.calculationDate} style={{ marginRight: '4px', zIndex: '2' }}>{new Date(oos2days.firstDayDate).toLocaleDateString('en-us', { weekday: 'short', year: 'numeric', month: 'numeric', day: 'numeric', timeZone: 'UTC' })}</p>}
        {oos2days.secondDayDate && <p className={styles.calculationDate} style={{ marginRight: '4px', zIndex: '2' }}>{(oos2days.firstDayDate && !oos2days.thirdDayDate) ? '& ' : ', '} {new Date(oos2days.secondDayDate).toLocaleDateString('en-us', { weekday: 'short', year: 'numeric', month: 'numeric', day: 'numeric', timeZone: 'UTC' })}</p>}
        {oos2days.thirdDayDate && <p className={styles.calculationDate} style={{ zIndex: '2' }}>{oos2days.secondDayDate && '& '} {new Date(oos2days.thirdDayDate).toLocaleDateString('en-us', { weekday: 'short', year: 'numeric', month: 'numeric', day: 'numeric', timeZone: 'UTC' })}</p>}
      </div>
      <CalculationOOSLongTwoDayParams commonValues={commonValues} department={department}
        outOfState={outOfState} oos2days={oos2days} unpDepartment={unpDepartment} selectedMiscCheckMarks={selectedMiscCheckMarks}
        formChange={formChange}
        resetLastTarget={resetLastTarget}
        checkboxValueChange={checkboxValueChange}
        editorState={editorState}
        calculationData={calculationData}
        tags={tags}
        popUpShown={popUpShown}
        setPreviewText={setPreviewText}
        setOptionsPreviewText={setOptionsPreviewText}
        setShowGenerateEmail={setShowGenerateEmail}
        furniture={furniture}
        roomsAreas={roomsAreas}
        setTagsValuesDefault={setTagsValuesDefault}
        customTagsValues={customTagsValues}
        showCustomTags={showCustomTags}
      />
      {/*       <CalculationTwoDaysPayment calculationData={calculationData} /> */}
    </section>
  );
};
